export default __webpack_public_path__ + "static/media/logo.a092386a.svg";